export function rebateAmount(listPrice) {
  const commissionEarned = listPrice * 0.03
  const minimumCommission = 2500
  const isEligibleForRebate = commissionEarned >= minimumCommission
  if (!isEligibleForRebate) return 0
  const maximumRebate = 250
  let rebate = commissionEarned - minimumCommission
  rebate = rebate > maximumRebate ? maximumRebate : rebate
  return rebate
}

export const padCommas = (str) =>
  str && str.length ? str.replace(/,/g, ', ') : str

export function removeFromArray(array, index) {
  return [...array.slice(0, index), ...array.slice(index + 1)]
}

export function mergeInArray(array, index, object) {
  return [...array.slice(0, index), object, ...array.slice(index + 1)]
}

export const toUSD = (n = 0) =>
  Number(n).toLocaleString('en-US', { style: 'currency', currency: 'USD' })

export function displayStatus(status) {
  switch (status) {
    case 'ActiveUnderContract':
    case 'Pending': {
      return 'Under Contract'
    }
    default: {
      return status
    }
  }
}

export function pluralize(number, word) {
  if (number === 1) {
    return word
  }
  return word + 's'
}



// WEBPACK FOOTER //
// ./src/utils/index.js